import { render, staticRenderFns } from "./LivingOptionPolygons.vue?vue&type=template&id=2cb8a876&scoped=true"
import script from "./LivingOptionPolygons.vue?vue&type=script&lang=js"
export * from "./LivingOptionPolygons.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionPolygons.vue?vue&type=style&index=0&id=2cb8a876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8a876",
  null
  
)

export default component.exports